// Date « aujourd'hui » au format AAAA-MM-JJ selon l'heure LOCALE du navigateur
// (Montréal pour les utilisateurs), et non UTC. `new Date().toISOString()`
// renvoie toujours l'UTC, ce qui décale d'un jour en soirée à Montréal.
export function todayLocal() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const j = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${j}`;
}
